import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  wrapper: css`
    position: relative;
    margin: 16px 16px 12px 16px;
  `,
  favoriteIcon: css`
    position: absolute;
    top: 0;
    right: 0;
  `,
  container: css`
    display: flex;
    flex-direction: row;
    height: ${pxToRem(158)};
    width: 100%;
    border-radius: 5px;
    margin-bottom: 12px;
    margin-top: 16px;
    cursor: pointer;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
  orgName: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media only screen and (max-width: 480px) {
      max-width: 70%;
    }
  `,
  title: css`
    max-width: 85%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  `,
  flyer: css`
    img {
      object-fit: contain;
      border-radius: 5px;
      margin-right: 8px;
    }
  `,
  skeletonContent: css`
    padding: 0px 0px 8px 16px;
    width: 100%;
  `,
  content: css`
    display: flex;
    flex-direction: row;
    width: 100%;
  `,
  agesOrGradesContainer: css`
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  `,
  titleExpired: css`
    color: ${colors.slate};
  `,
  expiredDate: css`
    color: ${colors.stone};
  `,
  schoolLogo: css`
    object-fit: cover;
    max-height: 24px;
    width: auto;
    max-width: 24px;
  `,
  loader: css`
    min-height: ${pxToRem(158)};
  `,
  disabledFlyer: css`
    opacity: 70%;
  `,
  schoolIconContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  `,
  removedFlyerLabel: css`
    margin-top: 24px;
  `,
};

export default styles;
